const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

const toRadians = (degrees) => (degrees * Math.PI) / 180;

/** Caixa que envolve a imagem depois de girada, para nada ser cortado. */
const rotatedBounds = (width, height, rotation) => {
  const rad = toRadians(rotation);
  return {
    width: Math.abs(Math.cos(rad) * width) + Math.abs(Math.sin(rad) * height),
    height: Math.abs(Math.sin(rad) * width) + Math.abs(Math.cos(rad) * height),
  };
};

export const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const extensionForType = (type) =>
  type === "image/png" ? "png" : type === "image/webp" ? "webp" : "jpg";

/**
 * Recorta a imagem no retângulo devolvido pelo cropper.
 *
 * O recorte roda com `restrictPosition={false}`, então o retângulo pode cair
 * fora da imagem quando o usuário dá zoom out — nesse caso a sobra é pintada
 * com `background` em vez de esticar a foto. O canvas usa os pixels originais,
 * sem reamostrar para um tamanho fixo, para a foto não sair borrada.
 */
export const getCroppedBlob = async (
  imageSrc,
  pixelCrop,
  { rotation = 0, outputType = "image/jpeg", background = "#ffffff" } = {}
) => {
  if (!imageSrc || !pixelCrop?.width || !pixelCrop?.height) return null;

  const image = await createImage(imageSrc);
  const bounds = rotatedBounds(image.naturalWidth, image.naturalHeight, rotation);

  const rotated = document.createElement("canvas");
  rotated.width = Math.round(bounds.width);
  rotated.height = Math.round(bounds.height);

  const rotatedCtx = rotated.getContext("2d");
  rotatedCtx.translate(rotated.width / 2, rotated.height / 2);
  rotatedCtx.rotate(toRadians(rotation));
  rotatedCtx.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

  const output = document.createElement("canvas");
  output.width = Math.max(1, Math.round(pixelCrop.width));
  output.height = Math.max(1, Math.round(pixelCrop.height));

  const ctx = output.getContext("2d");
  ctx.imageSmoothingQuality = "high";

  // PNG mantém transparência; os demais formatos ganham fundo sólido.
  if (outputType !== "image/png" && background) {
    ctx.fillStyle = background;
    ctx.fillRect(0, 0, output.width, output.height);
  }

  ctx.drawImage(rotated, -Math.round(pixelCrop.x), -Math.round(pixelCrop.y));

  return new Promise((resolve) => {
    output.toBlob(
      (blob) => resolve(blob),
      outputType,
      outputType === "image/png" ? undefined : 0.92
    );
  });
};
